// extracted by mini-css-extract-plugin
export default {"textarea":"statement_section-module___textarea___e5ec24f8"};